import React, { useState, useEffect } from 'react';
import { rootURL } from "../../constants";
import Cookies from 'js-cookie';

interface SlackAuthProps {
  onTokenReceived?: (token: string) => void;
  onUserNameReceived?: (username: string) => void;
  disabled: boolean;
}

const SlackAuth: React.FC<SlackAuthProps> = ({ disabled = false }) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [userData, setUserData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  // Check for token in URL when component mounts
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const slackToken = urlParams.get('slack_token');
    
    if (slackToken) {
      setAccessToken(slackToken);
      Cookies.set('slack_access_token', slackToken, { path: '/', expires: 3 }); // Cookie will expire in 3 days

      // Clean up URL parameters (optional)
      // window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <div style={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'flex-end' }}>
      <a 
        href={`${rootURL}/social-auth/login/slack`}
        style={{
          backgroundColor: disabled ? '#6b7280' : '#4A154B',
          color: 'white',
          padding: '6px 12px',
          borderRadius: '4px',
          border: 'none',
          fontFamily: 'Lato, sans-serif',
          fontSize: '13px',
          fontWeight: 'bold',
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          width: '100%',
          maxWidth: '200px',
          minWidth: '0',
          height: 'auto',
          boxSizing: 'border-box',
          justifyContent: 'center',
        }}
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="18" 
          height="18" 
          viewBox="0 0 48 48"
          style={{ marginRight: '8px', flexShrink: 0 }}
        >
          <path fill="#33d375" d="M33,8c0-2.209-1.791-4-4-4s-4,1.791-4,4c0,1.254,0,9.741,0,11c0,2.209,1.791,4,4,4s4-1.791,4-4	C33,17.741,33,9.254,33,8z"></path>
          <path fill="#33d375" d="M43,19c0,2.209-1.791,4-4,4c-1.195,0-4,0-4,0s0-2.986,0-4c0-2.209,1.791-4,4-4S43,16.791,43,19z"></path>
          <path fill="#40c4ff" d="M8,14c-2.209,0-4,1.791-4,4s1.791,4,4,4c1.254,0,9.741,0,11,0c2.209,0,4-1.791,4-4s-1.791-4-4-4	C17.741,14,9.254,14,8,14z"></path>
          <path fill="#40c4ff" d="M19,4c2.209,0,4,1.791,4,4c0,1.195,0,4,0,4s-2.986,0-4,0c-2.209,0-4-1.791-4-4S16.791,4,19,4z"></path>
          <path fill="#e91e63" d="M14,39.006C14,41.212,15.791,43,18,43s4-1.788,4-3.994c0-1.252,0-9.727,0-10.984	c0-2.206-1.791-3.994-4-3.994s-4,1.788-4,3.994C14,29.279,14,37.754,14,39.006z"></path>
          <path fill="#e91e63" d="M4,28.022c0-2.206,1.791-3.994,4-3.994c1.195,0,4,0,4,0s0,2.981,0,3.994c0,2.206-1.791,3.994-4,3.994	S4,30.228,4,28.022z"></path>
          <path fill="#ffc107" d="M39,33c2.209,0,4-1.791,4-4s-1.791-4-4-4c-1.254,0-9.741,0-11,0c-2.209,0-4,1.791-4,4s1.791,4,4,4	C29.258,33,37.746,33,39,33z"></path>
          <path fill="#ffc107" d="M28,43c-2.209,0-4-1.791-4-4c0-1.195,0-4,0-4s2.986,0,4,0c2.209,0,4,1.791,4,4S30.209,43,28,43z"></path>
        </svg>
                <span style={{ 
          overflow: 'hidden', 
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
          flex: 1,
          textAlign: 'center',
        }}>
          Login with Slack
        </span>
      </a>
    </div>
  );
};

export default SlackAuth;
